import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Listar from '../../../../components/auth/leis/listar'


function ListarLeiScreen() {

    return (
        <Fragment>
            <Head titulo="Leis Cadastradas - Módulo Legislativo" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarLeiScreen;